import type { FaireProductEntity } from "../../entity_types/product";

export const p_cgmqnje22r: FaireProductEntity = {
  token: "p_cgmqnje22r",
  type: "product",
  name: "Harper Stripe Scallop Knit Women's Cardigan (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/d33e9023d840e46793247caa63fa8426eceb9a95374f804a94a4cce0549d9079.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5ab1583ee41d2598858a172aab542e2ad2e1cffa9c82880f4aa5a13a39e7fc7.png",
    "https://cdn.faire.com/fastly/9a9893afa8d50bbb72e0d23f7a5dfaf2f274b4d242f4b2c5cef21f0c4a07a56a.png",
  ],
  priceDollars: 44,
  description:
    "A fresh, easygoing layer from Viverano’s SS27 collection, the Harper Stripe Scallop Cardigan is crafted from certified organic cotton with a relaxed drop-shoulder silhouette. Designed with short sleeves, a button-front closure, and sweet scalloped detailing at the collar and sleeve edges, it brings a soft vintage charm to warm-weather dressing.\n\nHorizontal harbor green stripes with delicate pointelle detailing add texture, breathability, and a playful spring feel. Thoughtfully made for comfort and everyday beauty, this cardigan is perfect for layering over dresses, tanks, or tees.\n\nCreated to coordinate beautifully with matching Mommy & Me baby styles, this cardigan blends comfort, craftsmanship, and sustainability. Designed in the USA and ethically produced in India, it’s made to be worn, loved, and cherished.",
  tags: [],
  msrpDollars: 88,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:32.419Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
